import React, { FC } from 'react';
import './Tabs.css';
//
// Рисует вкладки для переключения.
// Надо потом переписать компонент DateSwitch на использование этого как базового.
//
export interface TabsProps {
    list: string[];
    current: string;
    onChange?: (value: string) => void;
    className?: 'white'|'oldlace';
};

const Tabs: FC<TabsProps> = ({ list, current, onChange, className }) => {

    const draw = (item: string, index: number) => {
        if(item === current)
            return <div key={index} className='current'>{item}</div>;
        else
            return <div key={index} onClick={() => {if(onChange) onChange(item)}}>{item}</div>;
    };

    return (
        <div className={className ? `Tabs ${className}` : 'Tabs'}>
            <div/>
            {list.map((item, index) => draw(item, index))}
            <div/>
        </div>
	);
};

export default Tabs;
